// Field (magic-link) session token store — bearer is the PRIMARY transport
// because httpOnly cookies are not reliably persisted by iOS home-screen
// PWAs. IndexedDB is the durable store, localStorage the mirror, memory
// the hot copy the axios interceptor reads synchronously.
const DB_NAME = "serviceops_field_auth";
const STORE = "auth";
const KEY = "field_session";
const LS_KEY = "abs_field_session";

let _token = null;

function openDB() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return resolve(null);
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function idbGet() {
  const db = await openDB();
  if (!db) return null;
  return new Promise((resolve) => {
    const r = db.transaction(STORE, "readonly").objectStore(STORE).get(KEY);
    r.onsuccess = () => resolve(r.result || null);
    r.onerror = () => resolve(null);
  });
}

async function idbPut(value) {
  const db = await openDB();
  if (!db) return;
  await new Promise((resolve) => {
    const tx = db.transaction(STORE, "readwrite");
    if (value) tx.objectStore(STORE).put(value, KEY); else tx.objectStore(STORE).delete(KEY);
    tx.oncomplete = resolve; tx.onerror = resolve;
  });
}

export const fieldSessionReady = (async () => {
  try {
    _token = (await idbGet()) || localStorage.getItem(LS_KEY) || null;
    if (_token) { try { localStorage.setItem(LS_KEY, _token); } catch { /* private mode */ } }
    try { await navigator.storage?.persist?.(); } catch { /* unsupported */ }
  } catch { _token = null; }
  return _token;
})();

export const getFieldToken = () => _token;

export async function setFieldToken(token) {
  _token = token || null;
  try { token ? localStorage.setItem(LS_KEY, token) : localStorage.removeItem(LS_KEY); } catch { /* private mode */ }
  try { await idbPut(token || null); } catch { /* ignore */ }
}

export const clearFieldToken = () => setFieldToken(null);
